export default __webpack_public_path__ + "static/media/02__o_preview_1.2d39915f.jpg";